module.exports = __webpack_public_path__ + "static/media/pencil_green.66175313.png";